import React, { useEffect, useState } from "react";
import {
  Form,
  Button,
} from "react-bootstrap";
import toast from "react-hot-toast";
import { useNavigate } from "react-router";

import PublicService from '../../../services/public.service';
import "./Login.css";


const Login = () => {

  const [email, setEmail] = useState<string>();
  const [password, setPassword] = useState<string>();
  const navigate = useNavigate();

  const adminLogin = () => {
    PublicService.userLogin(email, password).then(res => {
      if (res.status === 200) {
        toast.success("Login Success")
        sessionStorage.setItem("authkey", res.data.data.token);
        sessionStorage.setItem("email", res.data.data.admin);
        navigate('/dashboard/statistics');
      }
    }).catch(e => {
      console.error(e)
      toast.error("Failed To login")
    })
  }

  useEffect(()=>{
    if(sessionStorage.getItem("authkey")){
      navigate("/dashboard/statistics")
    }
  },[])


  return (
    <div className="xcn-login-page">
      <div className="xcn-login-bg-circle xcn-circle-1"></div>
      <div className="xcn-login-bg-circle xcn-circle-2"></div>

      <div className="xcn-login-wrapper-new">
        {/* Logo */}
        <div className="xcn-header-logo">
          <svg width="32" height="32" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="40" height="40" rx="8" fill="#6c5ce7" />
            <path d="M20 12V28M12 20H28" stroke="white" strokeWidth="2" strokeLinecap="round" />
          </svg>
          <span>NIXAUTH</span>
        </div>

        <div className="xcn-login-card-new">
          <div className="xcn-form-section">
            <h2>Login as Admin</h2>

            <Form className="xcn-form-new">
              <Form.Group className="xcn-input-group">
                <Form.Control
                  type="email"
                  placeholder="Email address"
                  value={email || ''}
                  onChange={(e: any) => setEmail(e.target.value)}
                  className="xcn-input-field"
                />
              </Form.Group>

              <Form.Group className="xcn-input-group">
                <Form.Control
                  type="password"
                  placeholder="Password"
                  value={password || ''}
                  onChange={(e: any) => setPassword(e.target.value)}
                  className="xcn-input-field"
                />
              </Form.Group>

              <Button className="xcn-btn-login" onClick={adminLogin}>
                Sign In
              </Button>
            </Form>

            <div className="xcn-login-footer-links">
              <a href="#">Forgot password?</a>
              <a href="#">Get help</a>
            </div>
          </div>

          <div className="xcn-illustration-section">
            <svg viewBox="0 0 250 320" fill="none" xmlns="http://www.w3.org/2000/svg">
              {/* Decorative circles */}
              <circle cx="50" cy="60" r="20" fill="#FF6B6B" opacity="0.12" />
              <circle cx="200" cy="280" r="18" fill="#4ECDC4" opacity="0.12" />

              {/* Monitor Frame */}
              <rect x="60" y="90" width="130" height="100" rx="10" fill="none" stroke="#6c5ce7" strokeWidth="3" />
              <rect x="67" y="97" width="116" height="86" fill="#f5f7ff" rx="8" />

              {/* Screen shine/gloss */}
              <rect x="67" y="97" width="116" height="20" fill="#ffffff" opacity="0.35" rx="8" />

              {/* Screen content - text lines */}
              <rect x="80" y="120" width="45" height="5" fill="#6c5ce7" opacity="0.5" rx="2" />
              <rect x="80" y="135" width="70" height="3" fill="#6c5ce7" opacity="0.25" rx="1" />
              <rect x="80" y="145" width="70" height="3" fill="#6c5ce7" opacity="0.25" rx="1" />
              <rect x="80" y="155" width="50" height="3" fill="#6c5ce7" opacity="0.25" rx="1" />

              {/* Monitor stand/pedestal */}
              <rect x="100" y="195" width="50" height="28" fill="#d5d5d5" stroke="#999" strokeWidth="2" rx="3" />
              <rect x="85" y="223" width="80" height="6" fill="#999" rx="2" />

              {/* Shield with checkmark - positioned on monitor */}
              <g transform="translate(165, 125)">
                {/* Shield background */}
                <path d="M 0 -12 L 16 -4 L 16 10 Q 16 22 0 27 Q -16 22 -16 10 L -16 -4 Z"
                      fill="#6c5ce7" filter="drop-shadow(0 4px 8px rgba(108, 92, 231, 0.3))" />
                {/* Checkmark */}
                <path d="M -6 6 L 0 11 L 8 1" stroke="white" strokeWidth="2" fill="none"
                      strokeLinecap="round" strokeLinejoin="round" />
              </g>

              {/* Decorative dots */}
              <circle cx="90" cy="70" r="2.5" fill="#6c5ce7" opacity="0.3" />
              <circle cx="170" cy="85" r="2" fill="#6c5ce7" opacity="0.3" />
              <circle cx="120" cy="295" r="2" fill="#6c5ce7" opacity="0.3" />
            </svg>
          </div>
        </div>

        <div className="xcn-footer-links-new">
          <a href="#">Terms of use</a>
          <span>•</span>
          <a href="#">Privacy policy</a>
        </div>
      </div>
    </div>
  );
};

export default Login;
